<script setup lang="ts">
import {Tooltip as VTooltip} from 'floating-vue'

defineProps<{
  badgeClass: string
}>()
</script>

<template>
  <VTooltip theme="Rateboard">
    <span
      class="inline-flex max-w-full cursor-default items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold"
      :class="badgeClass"
    >
      <slot />
    </span>

    <template #popper>
      <slot name="popper" />
    </template>
  </VTooltip>
</template>
